import i18n from '../i18n';

export const PLAYER_UI_LOCALES = ['en', 'fr', 'de', 'it', 'es'];

/** i18n keys under phase2.playerProfile.localeOptions */
export const PLAYER_UI_LOCALE_LABEL_KEYS = {
  en: 'english',
  fr: 'french',
  de: 'german',
  it: 'italian',
  es: 'spanish',
};

export function isPlayerUiLocale(value) {
  if (value == null || value === '') return false;
  const code = String(value).replace(/^["']|["']$/g, '').split('-')[0];
  return PLAYER_UI_LOCALES.includes(code);
}

/** After auth verify / login: account locale wins if set; else keep localStorage / browser choice. */
export function applyVerifiedPlayerLanguage(savedUiLocale) {
  if (typeof window === 'undefined') return;
  const raw = window.localStorage.getItem('i18nextLng') || '';
  const fromStorage = String(raw).replace(/^["']|["']$/g, '').split('-')[0];
  const next = isPlayerUiLocale(savedUiLocale)
    ? savedUiLocale
    : isPlayerUiLocale(fromStorage)
      ? fromStorage
      : 'en';
  const current = (i18n.language || 'en').split('-')[0];
  if (current !== next) {
    void i18n.changeLanguage(next);
  }
}
